<template>
  <div class="page-con">
    <div class="finance-header" style="display: flex;align-items: center;margin-bottom: 10px;">
      <Button type="primary" style="margin-top: 10px;border-radius: 5px;" @click="createAccount">创建账号</Button>
      <Button type="primary" style="margin-top: 10px;margin-left: 10px;border-radius: 5px;" @click="addTax">添加税务机关
      </Button>
      <Button type="primary" style="margin-top: 10px;margin-left: 10px;border-radius: 5px;" @click="openManage">管理税务机关
      </Button>
      <div class="finance-span" style="margin-left: 10px;">
        <label>分局账号</label>
        <vxe-input v-model="taxExpertUserName" placeholder="请输入分局账号"></vxe-input>
      </div>
      <div class="finance-span">
        <label>税务机关</label>
        <Select v-model="taxIdList" multiple style="width: 255px" :max-tag-count="1"
                :max-tag-placeholder="maxTagPlaceholder">
          <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>
        </Select>
      </div>
      <div class="finance-span">
        <Button type="primary" style="border-radius: 5px" @click="search">搜索</Button>
        <Button style="border-radius: 5px;margin-left: 10px" @click="reset">重置</Button>
        <Button icon="md-refresh" style="border-radius: 5px;margin-left: 10px" @click="refresh">刷新</Button>
      </div>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          stripe
          class="table-style"
          align="center"
          highlight-hover-row
          max-height="680"
          border="none"
          :loading="loading"
          show-footer
          :data="tableData"
      >
        <vxe-table-column field="id" title="序号" width="100"></vxe-table-column>
        <vxe-table-column field="taxExpertUserName" title="分局账号" show-overflow></vxe-table-column>
        <vxe-table-column field="taxComp" title="所属税务机关" show-overflow></vxe-table-column>
        <vxe-table-column field="opt" title="操作" show-overflow>
          <template slot-scope="{ row }">
            <a style="cursor: pointer;color: #f40815;" @click="commitDelete(row.id)">删除</a>
            <a v-if="row.isUsed === 0" style="cursor: pointer;margin-left: 10px;color: #6fc74f;"
               @click="commitUse(row.id,1)">启用</a>
            <a v-if="row.isUsed === 1" style="cursor: pointer;margin-left: 10px;color: #f40815;"
               @click="commitUse(row.id,0)">禁用</a>
            <a style="cursor: pointer;margin-left: 10px;color: #348ef0;" @click="updatePsw(row)">修改密码</a>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="accVisible" :title="accTitle" width="500" height="350" @close="closeCreate" resize
               position="center" destroy-on-close>
      <create-account ref="accModal" :taxList="taxList" @close="closeCreate(1)"></create-account>
    </vxe-modal>
    <vxe-modal v-model="taxVisible" title="添加税务机关" width="500" height="200" @close="closeTax" resize
               position="center" destroy-on-close>
      <add-tax ref="taxModal" @close="closeTax"></add-tax>
    </vxe-modal>
    <vxe-modal v-model="manageVisible" title="管理税务机关" width="600" height="500" @close="closeManage" resize
               position="center" destroy-on-close>
      <tax-manage ref="manageModal" @close="closeManage"></tax-manage>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {getBlob, hideLoading, isEmpty, isNotEmpty, saveBlob, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";
import CreateAccount from "@/components/tax/CreateAccount";
import AddTax from "@/components/tax/AddTax";
import TaxManage from "@/components/tax/TaxManage";
import {apiPost} from "@/utils/api";

export default {
  mixins: [getAuthOrization],
  components: {CreateAccount, AddTax, TaxManage},
  data() {
    return {
      loading: false,
      searchLoading: false,
      tableData: [],
      accVisible: false,
      taxVisible: false,
      manageVisible: false,
      accTitle: '创建账号',
      taxIdList: [],
      taxList: [],
      taxOption: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      taxExpertUserName: null,
    }
  },
  mounted() {
    this.$bus.$on("税务端管理", () => {

    });
    this.getTaxList();
    this.getListData();
  },
  methods: {
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    async getTaxList() {
      let res = await $api.tax.post('getTaxList', {});
      if (res.status === 1) {
        this.taxList = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getListData() {
      this.loading = true;
      let res = await $api.tax.post("getTaxUserList", {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        taxExpertUserName: this.taxExpertUserName,
        taxIds: this.taxIdList
      });
      this.loading = false;
      if (res.status === 1) {
        let data = res.data;
        this.page.totalResult = data.total;
        this.tableData = data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reset(){
      this.taxExpertUserName = null;
      this.taxIdList = [];
    },
    handlePageChange(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.getListData();
    },
    createAccount() {
      this.accTitle = '创建账号';
      this.accVisible = true;
      this.$nextTick(() => {
        this.$refs.accModal.reset();
      });
    },
    closeCreate(e) {
      this.accVisible = false;
      if (e) {
        this.refresh();
      }
    },
    addTax() {
      this.taxVisible = true;
    },
    closeTax() {
      this.taxVisible = false;
    },
    openManage() {
      this.manageVisible = true;
      this.$nextTick(() => {
        this.$refs.manageModal.init();
      })
    },
    closeManage() {
      this.manageVisible = false;
      this.getTaxList();
      this.getListData();
    },
    search() {
      this.page.currentPage = 1;
      this.getListData();
    },
    refresh() {
      this.getListData();
    },
    updatePsw(row) {
      this.accTitle = '修改密码';
      this.accVisible = true;
      this.$nextTick(() => {
        this.$refs.accModal.setUpdate(row);
      })
    },
    commitUse(id, value) {
      let message = value ? '是否启用该账户?' : '是否禁用该账户?';
      this.$XModal.confirm(message).then(type => {
        if (type === "confirm") {
          this.using(id, value)
        }
      });
    },
    async using(id, value) {
      showLoading();
      let res = await $api.tax.post('forbidTaxUser', {
        id: id,
        state: value
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("操作成功");
        this.getListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitDelete(id) {
      this.$XModal.confirm("删除后不可恢复,是否删除账户?").then(type => {
        if (type === "confirm") {
          this.delete(id)
        }
      });
    },
    async delete(id) {
      showLoading();
      let res = await $api.tax.post('delTaxUser', {
        id: id
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.getListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}

</script>


<style>

</style>